import { combineReducers } from "redux";

import assessmentQuestion from "./containers/assessmentQuestion/reducer";
import addAssessmentQuestion from "./containers/addAssessmentQuestion/reducer";
import assessmentTest from "./containers/assessmentTest/reducer";
import addAssessmentTest from "./containers/addAssessmentTest/reducer";
import addContest from "./containers/addContest/reducer";
import contest from "./containers/contest/reducer";
const IndexReducer = combineReducers({
  assessmentQuestion,
  addAssessmentQuestion,
  assessmentTest,
  addAssessmentTest,
  addContest,
  contest
});

export default IndexReducer;
